$(document).ready(function () {
    $('.toggle-password').each(function () {
        const icon = $(
            '<svg width="24" height="24"><use href="/public/dist/svg/defs.svg#show"></use></svg>'
        )
        $(this).prepend(icon.clone())
        $(this)
            .find('svg')
            .on('click', function () {
                const input = $(this).siblings('.input')
                if (input.attr('type') === 'password') {
                    input.attr('type', 'text')
                    $(this)
                        .find('use')
                        .attr('href', '/public/dist/svg/defs.svg#hide')
                } else {
                    input.attr('type', 'password')
                    $(this)
                        .find('use')
                        .attr('href', '/public/dist/svg/defs.svg#show')
                }
            })
    })
})
